/* eslint-disable no-use-before-define */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable space-before-function-paren */
/* eslint-disable func-names */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as d3 from 'd3';
import { saveAs } from 'file-saver';

const last = (selection: any) => d3.select(selection.nodes()[selection.size() - 1]);

/**
 *
 * @param selection - D3 selection of elements
 * @param width - width allowance for the selection
 * @param padding - 1 corresponds to no padding, 1.5 is 50% padding
 */
export function getClutteredElements(selection: d3.Selection<any, any, any, any>, width: number, padding = 2, alwaysKeepLast = false) {
  const maxWidth = getMaxWidth(selection);
  const indices = getIndicesToDisplay(selection.size(), Math.floor(width / maxWidth / padding), alwaysKeepLast);
  return selection.filter((d, i) => !indices.includes(i));
}

export function getMaxWidth(selection: d3.Selection<any, any, any, any>) {
  let maxWidth = 0;
  selection.each(function() {
    maxWidth = Math.max(
      maxWidth,
      d3
        .select(this)
        .node()
        .getBoundingClientRect().width
    );
  });
  return maxWidth;
}

export function getIndicesToDisplay(numValues: number, numValuesToDisplay: number, alwaysShowLast = false) {
  const step = Math.max(1, Math.round(numValues / numValuesToDisplay));
  const indices = d3.range(0, numValues, step);
  if (indices.length < 3) {
    return [0, numValues - 1];
  }
  if (alwaysShowLast && (numValues - 1) % step !== 0) {
    indices.push(numValues - 1);
    indices.splice(indices.length - 2, 1);
  }
  return indices;
}

// places tooltip within container with config options
export function placeTooltip(
  tooltip: d3.Selection<any, any, any, any>,
  container: d3.Selection<any, any, any, any>,
  { verticalAnchor = 'bottom', horizontalAnchor = 'center', x = 0, y = 0, position = 'relative', fitInContainer = true } = {}
): void {
  // svg is the container used for absolute positioning and for setting a bounding box
  const contentRect = tooltip.node().getBoundingClientRect();
  const containerRect = container.node().getBoundingClientRect();
  const contentWidth = contentRect.width;
  let tooltipLeftEdge = x;
  if (position === 'relative') tooltipLeftEdge += containerRect.left;
  if (horizontalAnchor === 'center') tooltipLeftEdge -= contentWidth / 2;
  if (horizontalAnchor === 'right') tooltipLeftEdge -= contentWidth;
  // eslint-disable-next-line
  const containerRightEdge = containerRect.left + containerRect.width - 5; // padding

  // If the right edge of tooltip is beyond the right edge of the container,
  // fix the tooltip to the edge of the container:
  if (fitInContainer) {
    if (tooltipLeftEdge > containerRightEdge - contentWidth) {
      tooltipLeftEdge = containerRightEdge - contentWidth;
    } else if (tooltipLeftEdge < containerRect.left) {
      tooltipLeftEdge = containerRect.left;
    }
  }
  let tooltipTopEdge = y + window.scrollY;
  if (position === 'relative') tooltipTopEdge += containerRect.top;
  if (verticalAnchor === 'bottom') tooltipTopEdge -= contentRect.height;
  if (fitInContainer && tooltipTopEdge < containerRect.top) {
    tooltipTopEdge = containerRect.top;
  }

  if (tooltip.classed('left-edge')) {
    // move to place 40% to the right so that the tooltip carrot is on the left side
    tooltipLeftEdge += contentWidth * 0.35;
  }

  tooltip
    .style('top', `${tooltipTopEdge}px`)
    .style('left', `${tooltipLeftEdge}px`)
    .style('visibility', 'visible');
}

// generates innerHTML for tooltip based on title and a map of key:value pairs
export function keyValueTitleTooltip(tooltip: d3.Selection<HTMLDivElement, any, any, any>, title: string, map: { [key: string]: any }): void {
  tooltip.classed('key-value-tooltip', true).html('');
  if (title) {
    tooltip
      .append('p')
      .attr('class', 'text-xs font-bold mb-1')
      .text(title);
  }
  tooltip
    .selectAll('p.value')
    .data(Object.keys(map))
    .enter()
    .append('p')
    .attr('class', 'value text-xs')
    .html((d: any) => `<span class="font-medium">${d}:</span> ${map[d]}`);
}

export function svgLineWrap(text: d3.Selection<any, any, any, any>, width: number, height: number, verticalAlign: boolean): void {
  text.each(function() {
    const words = text
      .text()
      .split(/\s+/)
      .reverse();
    let word: string | undefined;
    let totalHeight: number;
    let line: string[] = [];
    let lastLine: d3.Selection<any, any, any, any>;
    let lineNumber = 0;
    const lineHeight = 1.1; // ems
    const x = text.attr('x');
    const y = text.attr('y');
    let tspan = text
      .text(null)
      .append('tspan')
      .attr('x', x)
      .attr('y', y)
      .attr('dy', '1em');
    // eslint-disable-next-line
    while ((word = words.pop())) {
      // while there are still words, take off the next one and...
      line.push(word); // add the word
      tspan.text(line.join(' ')); // modify the tspan to match the line
      // eslint-disable-next-line
      if (tspan.node()!.getComputedTextLength() > width) {
        // if the next word won't fit on the line...
        line.pop(); // then pull it off
        if (line.length === 0) {
          lineNumber--;
        }
        tspan.text(line.join(' ')); // recreate the line without the word
        line = [word]; // assign the last word that wouldn't fit to the new line and then assign it to a new tspan
        tspan = text
          .append('tspan')
          .attr('x', x)
          .attr('y', y)
          .attr('dy', `${++lineNumber * lineHeight + 1}em`)
          .text(word);
      }
    }
    /* eslint-disable @typescript-eslint/no-non-null-assertion */

    totalHeight = text.node()!.getBBox().height;
    while (totalHeight > height) {
      text
        .selectAll('tspan')
        .call(last)
        .remove();
      totalHeight = text.node()!.getBBox().height;
    }
    // add ellipsis if over length
    // eslint-disable-next-line
    lastLine = text.selectAll('tspan').call(last);
    lastLine.call((g) => wrapLine(g, width));
    totalHeight = text.node()!.getBBox().height;
    if (verticalAlign) {
      text.attr('transform', `translate(0, ${(height - totalHeight) / 2})`);
    }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */
  });
}

export function wrapLine(textSelection: d3.Selection<SVGTextElement, any, any, any>, width: number): void {
  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  let textLength = textSelection.node()!.getComputedTextLength();
  let text = textSelection.text();
  while (textLength > width && text.length > 0) {
    text = text.slice(0, -1);
    textSelection.text(`${text}…`);
    textLength = textSelection.node()!.getComputedTextLength();
  }
  /* eslint-enable @typescript-eslint/no-non-null-assertion */
}

export function exportSvgAsPng(
  svgNode: SVGSVGElement,
  options: {
    customCss?: string;
    scale?: number;
    fileName?: string;
    backgroundColor?: string;
    title?: string;
    titleMargin?: number;
  }
): void {
  const width = svgNode.clientWidth;
  const height = svgNode.clientHeight;
  const svgString = getSVGString(svgNode, options.customCss || null);
  const scale = options.scale || 1;
  svgStringToImage(
    svgString,
    {
      width: width * scale,
      height: height * scale,
      backgroundColor: options.backgroundColor,
      title: options.title,
      titleMargin: (options.titleMargin || 0) * scale,
    },
    (blob: Blob) => {
      saveAs(blob, `${options.fileName || options.title || 'Chart Export'}.png`);
    }
  );
}

function appendCssToSvg(cssText: string, element: SVGSVGElement): void {
  const styleElement = document.createElement('style');
  styleElement.setAttribute('type', 'text/css');
  styleElement.innerHTML = cssText;
  const refNode = element.hasChildNodes() ? element.children[0] : null;
  element.insertBefore(styleElement, refNode);
}

function getSVGString(svgNode: SVGSVGElement, cssText: string | null): string {
  svgNode.setAttribute('xlink', 'http://www.w3.org/1999/xlink');
  if (cssText) {
    appendCssToSvg(cssText, svgNode);
  }

  const serializer = new XMLSerializer();
  let svgString = serializer.serializeToString(svgNode);
  svgString = svgString.replace(/(\w+)?:?xlink=/g, 'xmlns:xlink='); // Fix root xlink without namespace
  svgString = svgString.replace(/NS\d+:href/g, 'xlink:href'); // Safari NS namespace fix

  return svgString;
}

function svgStringToImage(
  svgString: string,
  options: { width: number; height: number; backgroundColor?: string; title?: string; titleMargin?: number },
  callback: (blob: Blob) => void
) {
  const imgsrc = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svgString)))}`; // Convert SVG string to data URL
  const titleHeight = options.title ? 96 : 0;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  canvas.width = options.width;
  canvas.height = options.height + titleHeight;
  if (!context) {
    return;
  }

  context.clearRect(0, 0, canvas.width, canvas.height);
  if (options.backgroundColor) {
    context.fillStyle = options.backgroundColor;
    context.fillRect(0, 0, canvas.width, canvas.height);
  }

  if (options.title) {
    context.fillStyle = '#252d39ee';
    context.font = 'bold 42px Inter var';
    context.fillText(options.title, options.width * 0.05 + (options.titleMargin || 16), 48 + options.height * 0.035);
  }

  const image = new Image();
  image.onload = () => {
    if (context) {
      context.drawImage(image, options.width * 0.05, titleHeight + options.height * 0.05, options.width * 0.9, options.height * 0.9);
      canvas.toBlob((blob) => {
        if (blob) {
          if (callback) {
            callback(blob);
            canvas.remove();
          }
        }
      });
    }
  };
  image.src = imgsrc;
}

export interface ISharedD3ChartProps {
  exportTitle?: string;
  exportFileName?: string;
}
